import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { fmtDateTime } from "../lib/date";
import { FaultMaintenanceActions } from "./RecordRepair";

const DEC = { safe_to_continue: ["Safe to continue", "bg-yellow-100 text-yellow-800"], restricted_use: ["Restricted use", "bg-amber-100 text-amber-900"], stop_using: ["Stop using", "bg-red-100 text-red-800"] };

// Maintenance "Needs attention" queue — every open fault not yet on a job card (Safe to continue included).
export function NeedsAttention() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/repairs/needs-attention").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (rows === null) return null;
  return (
    <section data-testid="needs-attention" className="bg-white border-2 border-amber-300 rounded-lg p-3 flex flex-col gap-2">
      <h2 className="font-display font-bold text-slate-900">Needs attention <span className="text-sm text-slate-500">({rows.length})</span></h2>
      {rows.length === 0 && <p className="text-sm text-slate-500">Nothing waiting.</p>}
      {rows.map((f) => {
        const [lbl, cls] = DEC[f.use_decision] || ["", ""];
        return (
          <div key={f.id} data-testid={`na-row-${f.id}`} className="border border-slate-200 rounded p-2.5 flex flex-col gap-1.5">
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <span data-testid={`na-decision-${f.id}`} className={`text-[10px] font-bold uppercase rounded px-1.5 py-0.5 ${cls}`}>{lbl}</span>
              <span className="font-semibold text-slate-800">{f.title || f.description}</span>
              <Link to={`/assets/${f.asset_id}`} className="text-xs text-blue-700">{f.asset}</Link>
              <span className="text-xs text-slate-500">Reported by {f.reporter} · {fmtDateTime(f.reported_at)}</span>
              {f.repair_status && <span className="text-xs font-semibold text-slate-600">· {f.repair_status.replace(/_/g, " ")}</span>}
            </div>
            <FaultMaintenanceActions fault={f} onDone={load} />
          </div>
        );
      })}
    </section>
  );
}
